import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import AutomaticLanding from 'src/components/Automatic/AutomaticLanding/AutomaticLanding';
import AddBankStandalone from 'src/components/Bank/AddBankStandalone/AddBankStandalone';
import BuyLanding from 'src/components/Buy/BuyLanding/BuyLanding';
import CollegeContributeLanding from 'src/components/CollegeContribute/CollegeContributeLanding/CollegeContributeLanding';
import CollegeDistributeLanding from 'src/components/CollegeDistribute/CollegeDistributeLanding/CollegeDistributeLanding';
import CollegeExchangeLanding from 'src/components/CollegeExchange/CollegeExchangeLanding/CollegeExchangeLanding';
import { AutoExchangeConfirmation } from 'src/components/Confirmation/Confirmation/AutoExchange';
import BuyConfirmation from 'src/components/Confirmation/Confirmation/Buy/BuyConfirmation';
import AppBuyConfirmation from 'src/components/Confirmation/Confirmation/AppBuy/AppBuyConfirmation';
import AppSellConfirmation from 'src/components/Confirmation/Confirmation/AppSell/AppSellConfirmation';
import CollegeContributeConfirmation from 'src/components/Confirmation/Confirmation/CollegeContribute/CollegeContributeConfirmation';
import CollegeDistributeConfirmation from 'src/components/Confirmation/Confirmation/CollegeDistribute/CollegeDistributeConfirmation';
import CollegeExchangeConfirmation from 'src/components/Confirmation/Confirmation/CollegeExchange/CollegeExchangeConfirmation';
import ExchangeConfirmation from 'src/components/Confirmation/Confirmation/Exchange/ExchangeConfirmation';
import RecurringBuyEditConfirmation from 'src/components/Confirmation/Confirmation/RecurringBuyEdit/RecurringBuyEditConfirmation';
import SellConfirmation from 'src/components/Confirmation/Confirmation/Sell/SellConfirmation';
import ExchangeLanding from 'src/components/Exchange/ExchangeLanding/ExchangeLanding';
import SellLanding from 'src/components/Sell/SellLanding/SellLanding';
import RothConversionLanding from 'src/components/RothConversion/RothConversionLanding/RothConversionLanding';
import RothConversionConfirmation from 'src/components/Confirmation/Confirmation/RothConversion/RothConversionConfirmation';
import QCDConfirmation from 'src/components/Confirmation/Confirmation/QCD/QCDConfirmation';
import QCDLanding from 'src/components/QCD/QCDLanding/QCDLanding';
import QCDEntry from 'src/components/QCD/QCDEntry/QCDEntry';
import {
  App,
  BuyConfirmationContainer,
  BuyContainer,
  CollegeContributeContainer,
  CollegeDistributeContainer,
  CollegeExchangeContainer,
  RecurringBuyConfirmationContainer,
  SellConfirmationContainer,
  SellContainer,
  TransactionLandingPage,
  RothConversionContainer,
} from 'src/containers';
import AutomaticContainer from 'src/containers/Automatic/AutomaticContainer';
import ExchangeContainer from 'src/containers/Exchange/ExchangeContainer';
import { getLocationUpdated } from 'src/redux/modules/automaticEdit/automaticEdit.selectors';
import { appendBasePath } from 'src/utils/nav.utils';
import { AutoSellLanding, AutoSellLandingProps } from '../AutoSell';
import {
  locationChange,
  setAdditionalParams,
} from '../../redux/modules/authentication/authentication.module';
import { AutoExchangeLanding } from '../Automatic/AutomaticExchange/Landing';
import {
  RecurringBuyConfirmation,
  RecurringBuyConfirmationProps,
} from '../Confirmation/Confirmation/RecurringBuy/RecurringBuyConfirmation';
import { AutoSellConfirmation } from '../Confirmation/Confirmation/AutoSell/index';
import { IRAAutoMaxConfirmation } from '../Confirmation/Confirmation/RecurringBuy/IRAAutoMaxConfirmation';
import { TransferFundingContainer } from '../../containers/TransferFunding/TransferFundingContainer';
import { RolloverFundingContainer } from '../../containers/RolloverFunding/RolloverFundingContainer';
import MailCheckContainer from '../../containers/MailACheck/MailCheckContainer';
import useAutomaxRetirement from 'src/components/IRAAutoMax/useAutomaxRetirement';
// import { TransferNextStepsContainer } from '../../containers/TransferNextSteps/TransferNextStepsContainer';

const Root: React.FC = (props) => {
  const dispatch = useDispatch();
  const locationLoaded = useSelector(getLocationUpdated);
  useEffect(() => {
    dispatch(locationChange());
    dispatch(setAdditionalParams());
  }, [dispatch]);

  const { AUTOMAX_RETIREMENT_YEAR, automaxYear } = useAutomaxRetirement();

  if (!locationLoaded) {
    return <div />;
  } else {
    return (
      <Router>
        <Route path={appendBasePath('/')}>
          <App {...props}>
            <Switch>
              <Route
                exact
                path={[
                  appendBasePath('/buy'),
                  appendBasePath('/salesforce/buy'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding {...props} />
                </BuyContainer>
              </Route>
              <Route
                path={[
                  appendBasePath('/buy/confirm'),
                  appendBasePath('/salesforce/buy/confirm'),
                ]}
              >
                <BuyConfirmationContainer {...props}>
                  <BuyConfirmation {...props} />
                </BuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/sell'),
                  appendBasePath('/salesforce/sell'),
                ]}
              >
                <SellContainer {...props}>
                  <SellLanding {...props} />
                </SellContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/sell/confirm'),
                  appendBasePath('/salesforce/sell/confirm'),
                ]}
              >
                <SellContainer {...props}>
                  <SellConfirmationContainer {...props}>
                    <SellConfirmation {...props} />
                  </SellConfirmationContainer>
                </SellContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/exchange'),
                  appendBasePath('/salesforce/exchange'),
                ]}
              >
                <ExchangeContainer {...props}>
                  <ExchangeLanding {...props} />
                </ExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/roth-conversion'),
                  appendBasePath('/salesforce/roth-conversion'),
                ]}
              >
                <RothConversionContainer {...props}>
                  <RothConversionLanding {...props} />
                </RothConversionContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/roth-conversion/confirm'),
                  appendBasePath('/salesforce/roth-conversion/confirm'),
                ]}
              >
                <RothConversionContainer {...props}>
                  <RothConversionConfirmation {...props} />
                </RothConversionContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/qcd/confirm'),
                  appendBasePath('/salesforce/qcd/confirm'),
                ]}
              >
                <QCDConfirmation {...props} />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/exchange/confirm'),
                  appendBasePath('/salesforce/exchange/confirm'),
                ]}
              >
                <ExchangeContainer {...props}>
                  <ExchangeConfirmation {...props} />
                </ExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/contribute'),
                  appendBasePath('/salesforce/college/contribute'),
                ]}
              >
                <CollegeContributeContainer {...props}>
                  <CollegeContributeLanding {...props} />
                </CollegeContributeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/contribute/confirm'),
                  appendBasePath('/salesforce/college/contribute/confirm'),
                ]}
              >
                <CollegeContributeContainer {...props}>
                  <CollegeContributeConfirmation {...props} />
                </CollegeContributeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/distribute'),
                  appendBasePath('/salesforce/college/distribute'),
                ]}
              >
                <CollegeDistributeContainer {...props}>
                  <CollegeDistributeLanding {...props} />
                </CollegeDistributeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/distribute/confirm'),
                  appendBasePath('/salesforce/college/distribute/confirm'),
                ]}
              >
                <CollegeDistributeContainer {...props}>
                  <CollegeDistributeConfirmation {...props} />
                </CollegeDistributeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/exchange'),
                  appendBasePath('/salesforce/college/exchange'),
                ]}
              >
                <CollegeExchangeContainer {...props}>
                  <CollegeExchangeLanding {...props} />
                </CollegeExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/college/exchange/confirm'),
                  appendBasePath('/salesforce/college/exchange/confirm'),
                ]}
              >
                <CollegeExchangeContainer {...props}>
                  <CollegeExchangeConfirmation {...props} />
                </CollegeExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic'),
                  appendBasePath('/salesforce/automatic'),
                ]}
              >
                <AutomaticContainer {...props}>
                  <AutomaticLanding {...props} />
                </AutomaticContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/buy'),
                  appendBasePath('/salesforce/automatic/buy'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding {...props} />
                </BuyContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/buy/confirm'),
                  appendBasePath('/salesforce/automatic/buy/confirm'),
                ]}
              >
                <RecurringBuyConfirmationContainer {...props}>
                  <RecurringBuyConfirmation
                    {...(props as RecurringBuyConfirmationProps)}
                  />
                </RecurringBuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/ira-automax'),
                  appendBasePath('/salesforce/automatic/ira-automax'),
                  appendBasePath('/automatic/ira-automax/edit'),
                  appendBasePath('/salesforce/automatic/ira-automax/edit'),
                ]}
              >
                {automaxYear > AUTOMAX_RETIREMENT_YEAR ? (
                  <Redirect to={{ pathname: appendBasePath('/automatic') }} />
                ) : (
                  <BuyContainer {...props}>
                    <BuyLanding {...props} />
                  </BuyContainer>
                )}
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/ira-automax/confirm'),
                  appendBasePath('/salesforce/automatic/ira-automax/confirm'),
                ]}
              >
                {automaxYear > AUTOMAX_RETIREMENT_YEAR ? (
                  <Redirect to={{ pathname: appendBasePath('/automatic') }} />
                ) : (
                  <RecurringBuyConfirmationContainer {...props}>
                    <IRAAutoMaxConfirmation
                      {...(props as RecurringBuyConfirmationProps)}
                    />
                  </RecurringBuyConfirmationContainer>
                )}
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/buy/edit'),
                  appendBasePath('/salesforce/automatic/buy/edit'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding {...props} />
                </BuyContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/buy/edit/confirm'),
                  appendBasePath('/salesforce/automatic/buy/edit/confirm'),
                ]}
              >
                <RecurringBuyConfirmationContainer {...props}>
                  <RecurringBuyEditConfirmation
                    {...(props as RecurringBuyConfirmationProps)}
                  />
                </RecurringBuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/contribute'),
                  appendBasePath('/salesforce/automatic/contribute'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding {...props} />
                </BuyContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/contribute/confirm'),
                  appendBasePath('/salesforce/automatic/contribute/confirm'),
                ]}
              >
                <RecurringBuyConfirmationContainer {...props}>
                  <RecurringBuyConfirmation
                    {...(props as RecurringBuyConfirmationProps)}
                  />
                </RecurringBuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/contribute/edit'),
                  appendBasePath('/salesforce/automatic/contribute/edit'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding {...props} />
                </BuyContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/contribute/edit/confirm'),
                  appendBasePath(
                    '/salesforce/automatic/contribute/edit/confirm'
                  ),
                ]}
              >
                <RecurringBuyConfirmationContainer {...props}>
                  <RecurringBuyEditConfirmation {...props} />
                </RecurringBuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/sell'),
                  appendBasePath('/salesforce/automatic/sell'),
                ]}
              >
                <SellContainer {...props}>
                  <AutoSellLanding {...(props as AutoSellLandingProps)} />
                </SellContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/sell/confirm'),
                  appendBasePath('/salesforce/automatic/sell/confirm'),
                ]}
              >
                <AutoSellConfirmation />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/sell/edit'),
                  appendBasePath('/salesforce/automatic/sell/edit'),
                ]}
              >
                <SellContainer {...props}>
                  <AutoSellLanding {...(props as AutoSellLandingProps)} />
                </SellContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/sell/edit/confirm'),
                  appendBasePath('/salesforce/automatic/sell/edit/confirm'),
                ]}
              >
                <AutoSellConfirmation />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/addbank'),
                  appendBasePath('/salesforce/addbank'),
                ]}
              >
                <AddBankStandalone />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/landing'),
                  appendBasePath('/salesforce/landing'),
                ]}
              >
                <TransactionLandingPage {...props} />
              </Route>
              <Route exact path={[appendBasePath('/funding/mail-check')]}>
                <MailCheckContainer {...props} />
              </Route>
              <Route exact path={[appendBasePath('/funding/transfer')]}>
                <TransferFundingContainer {...props} />
              </Route>
              <Route
                exact
                path={[appendBasePath('/funding/transfer/existing-account')]}
              >
                <TransferFundingContainer {...props} />
              </Route>
              <Route exact path={[appendBasePath('/funding/rollover')]}>
                <RolloverFundingContainer {...props} />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/exchange/confirm'),
                  appendBasePath('/salesforce/automatic/exchange/confirm'),
                ]}
              >
                <AutoExchangeConfirmation />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/exchange'),
                  appendBasePath('/salesforce/automatic/exchange'),
                ]}
              >
                <ExchangeContainer {...props}>
                  <AutoExchangeLanding />
                </ExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/exchange/edit/confirm'),
                  appendBasePath('/salesforce/automatic/exchange/edit/confirm'),
                ]}
              >
                <AutoExchangeConfirmation />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/automatic/exchange/edit'),
                  appendBasePath('/salesforce/automatic/exchange/edit'),
                ]}
              >
                <ExchangeContainer>
                  <AutoExchangeLanding />
                </ExchangeContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/advisory/add'),
                  appendBasePath('/salesforce/advisory/add'),
                ]}
              >
                <BuyContainer {...props}>
                  <BuyLanding />
                </BuyContainer>
              </Route>
              <Route
                path={[
                  appendBasePath('/advisory/add/confirm'),
                  appendBasePath('/salesforce/advisory/add/confirm'),
                ]}
              >
                <BuyConfirmationContainer {...props}>
                  <AppBuyConfirmation {...props} />
                </BuyConfirmationContainer>
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/advisory/withdraw'),
                  appendBasePath('/salesforce/advisory/withdraw'),
                ]}
              >
                <SellContainer {...props}>
                  <SellLanding />
                </SellContainer>
              </Route>
              <Route
                path={[
                  appendBasePath('/advisory/withdraw/confirm'),
                  appendBasePath('/salesforce/advisory/withdraw/confirm'),
                ]}
              >
                <SellContainer disableStyle {...props}>
                  <SellConfirmationContainer {...props}>
                    <AppSellConfirmation {...props} />
                  </SellConfirmationContainer>
                </SellContainer>
              </Route>

              <Route path={appendBasePath('/app/add')}>
                <Redirect to={{ pathname: appendBasePath('/advisory/add') }} />
              </Route>

              <Route path={appendBasePath('/app/withdraw')}>
                <Redirect
                  to={{ pathname: appendBasePath('/advisory/withdraw') }}
                />
              </Route>

              <Route
                exact
                path={[
                  appendBasePath('/qcd'),
                  appendBasePath('/salesforce/qcd'),
                ]}
              >
                <QCDLanding {...props} />
              </Route>
              <Route
                exact
                path={[
                  appendBasePath('/qcd/landing'),
                  appendBasePath('/salesforce/qcd/landing'),
                ]}
              >
                <QCDEntry {...props} />
              </Route>

              <Route path={appendBasePath('/salesforce/*')}>
                <Redirect
                  to={{ pathname: appendBasePath('/salesforce/landing') }}
                />
              </Route>
              <Route path={appendBasePath('*')}>
                <Redirect to={{ pathname: appendBasePath('/landing') }} />
              </Route>
            </Switch>
          </App>
        </Route>
      </Router>
    );
  }
};

export default Root;
